import { track } from '@eventbrite/datalayer-library';

import { ArrowRightIcon, Button, Typography } from '@eventbrite/marmalade';
import { useIsMobileDevice } from '@eventbrite/feature-detection';
import {
    VALENTINE_COLLECTION_TO_SLUG_MAPPING,
    SEASONAL_CONFIG,
    VALENTINES_SEASON,
} from '../../constants';
import React, { useEffect } from 'react';
import styles from './HolidayCollectionsTouchpoint.module.scss';

export const HolidayCollectionsTouchpoint = ({ collectionId }) => {
    const isMobile = useIsMobileDevice();
    useEffect(() => {
        if (collectionId in VALENTINE_COLLECTION_TO_SLUG_MAPPING) {
            track({
                eventName: 'CollectionsTouchpointView',
                eventData: {
                    season,
                    location:
                        VALENTINE_COLLECTION_TO_SLUG_MAPPING[collectionId],
                },
            });
        }
    }, [collectionId, season]);
    const handleClick = () => {
        track({
            eventName: 'CollectionsTouchpointClick',
            eventData: {
                season,
                location: VALENTINE_COLLECTION_TO_SLUG_MAPPING[collectionId],
            },
        });
    };
    if (!(collectionId in VALENTINE_COLLECTION_TO_SLUG_MAPPING)) {
        return null;
    }

    const season = VALENTINES_SEASON;

    const touchpointData = [
        {
            className: styles.holidayCollectionsTouchpointTitle,
            text: SEASONAL_CONFIG[season].touchpointTitle,
        },
        {
            className: styles.holidayCollectionsTouchpointSubtitle,
            text: SEASONAL_CONFIG[season].touchpointSubtitle(isMobile),
        },
    ];

    return (
        <div
            className={`${styles.holidayCollectionsTouchpoint} ${styles[season]}`}
        >
            <div
                className={`${styles.holidayCollectionsTouchpointContainer} ${styles[season]}`}
            >
                <div
                    className={
                        styles.holidayCollectionsTouchpointImageTextContainer
                    }
                >
                    <img
                        className={
                            styles.holidayCollectionsTouchpointImageContainer
                        }
                        src={SEASONAL_CONFIG[season].imageSrc(isMobile)}
                        alt="Holiday Touchpoint"
                    />
                    <div
                        className={
                            styles.holidayCollectionsTouchpointTextContainer
                        }
                        data-testid="holiday-collections-touchpoint-title-subtitle"
                    >
                        {touchpointData.map((item, index) => (
                            <Typography
                                key={index}
                                as="h2"
                                className={item.className}
                            >
                                {item.text}
                            </Typography>
                        ))}
                    </div>
                </div>
                <a
                    href={SEASONAL_CONFIG[season].ctaLink(collectionId)}
                    data-heap-id="holiday_collections_touchpoint_click"
                    onClick={handleClick}
                >
                    <Button
                        className={styles.holidayCollectionsTouchpointButton}
                    >
                        <span
                            className={
                                styles.holidayCollectionsTouchpointButtonText
                            }
                        >
                            {SEASONAL_CONFIG[season].ctaText}
                        </span>
                        <ArrowRightIcon
                            className={
                                styles.holidayCollectionsTouchpointArrowRight
                            }
                        />
                    </Button>
                </a>
            </div>
        </div>
    );
};

export default HolidayCollectionsTouchpoint;
